import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { getNewComponentId } from '@myia/ngx-core';
import { LocalizationService } from '@myia/ngx-localization';
import { ToastManager } from '@myia/ngx-toast';

// toast keys
const TOAST_MULTIPLE_FILES_IS_NOT_SUPPORTED = 'TOAST_MULTIPLE_FILES_IS_NOT_SUPPORTED';

@Component({
    selector: 'input-file',
    styleUrls: ['./inputFile.component.scss'],
    template: `
                <input #inputEl type="file" name="{{inputId}}" id="{{inputId}}" [attr.multiple]="multiple" [accept]="accept" class="inputFile" [ngClass]="{hasFocus: hasFocus}" (change)="onChange($event)" (blur)="onBlur()" (focus)="onFocus()" [disabled]="disabled"/>
                <label [attr.for]="inputId" class="inputFileLabel" [ngClass]="{disabled: disabled}"><ng-content></ng-content></label>
              `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputFileComponent implements OnInit {
    @Input() multiple = false;
    @Input() disabled = false;
    @Input() formGroupRef?: FormGroup;
    @Input() fieldName?: string;
    @Input() accept?: string;

    @HostBinding('class.inputFileBlock') hostClass = true;

    @ViewChild('inputEl', {static: true}) _input?: ElementRef;

    @Output() fileAdded: EventEmitter<any>;

    public inputId: string = 'input' + getNewComponentId();
    public hasFocus = false;

    private _control?: FormControl;

    constructor(private _changeDetectorRef: ChangeDetectorRef, private _toastManager: ToastManager, private _localizationService: LocalizationService) {
        this.fileAdded = new EventEmitter();
    }

    ngOnInit() {
        this._control = new FormControl('', Validators.compose([]));
        if (this.formGroupRef) {
            this.formGroupRef.addControl(this.fieldName || getNewComponentId(), this._control);
        }
    }


    onChange($event: Event) {
        const target = $event.target as HTMLInputElement;
        const files = target.files as FileList;
        if (files && files.length) {
            if (files.length > 1 && !this.multiple) {
                this._toastManager.warning(this._localizationService.translate('PhotoPicker.Multiple_Photos_Not_Supported'), { toastKey: TOAST_MULTIPLE_FILES_IS_NOT_SUPPORTED });
            }
            const inputFiles = this.multiple ? files : files[0];
            this._control?.setValue(inputFiles);
            this._control?.markAsTouched();
            this._changeDetectorRef.markForCheck();
            this.fileAdded.emit({file: inputFiles});
            if (this._input) {
                this._input.nativeElement.value = '';
            }
        }
    }

    onBlur() {
        this.hasFocus = false;
    }

    onFocus() {
        this.hasFocus = true;
    }
}
